
String.prototype.format = function(args) {
    let result = this;
    for (let i = 0; i < arguments.length; i++) {
        if (arguments[i] != undefined) {
            let reg= new RegExp("({)" + i + "(})", "g");
            result = result.replace(reg, arguments[i]);
        }
    }
	// 一定要转回去字符串，否则这里是一个StringObject
    return result.toString();
};